import React from "react";
import { Box, Skeleton } from "@mui/material";
import { dt } from "../../../shared/themes/redesignTokens";

const KioskDashboardSkeleton: React.FC = () => {
  return (
    <Box sx={{ fontFamily: dt.font }}>
      {/* Header skeleton */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "16px",
          backgroundColor: dt.cardBg,
          borderRadius: dt.radius,
          border: `1px solid ${dt.cardBorder}`,
          mb: 2,
        }}
      >
        <Skeleton variant="circular" width={72} height={72} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="70%" height={22} />
          <Skeleton variant="text" width="50%" height={18} sx={{ mt: 0.5 }} />
          <Skeleton variant="text" width="30%" height={16} sx={{ mt: 0.5 }} />
        </Box>
        <Skeleton variant="rounded" width={28} height={20} sx={{ borderRadius: "10px" }} />
      </Box>

      {/* Tiles skeleton */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "16px",
        }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            sx={{
              minHeight: "120px",
              borderRadius: dt.radius,
              animation: `tileEnter 0.4s cubic-bezier(0.4, 0, 0.2, 1) ${i * 0.06}s both`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default KioskDashboardSkeleton;
